import useInteractionTracker from '@blueshift-ui/telemetry/dist/hooks/use-interaction-tracker';
import { ChevronRight, Home } from 'lucide-react';
import Link from 'next/link';
import { memo } from 'react';

import { ROUTES } from '../constants';

interface ConceptBreadcrumbProps {
  breadcrumbTitle: string;
}

const ConceptBreadcrumb = memo(
  ({ breadcrumbTitle }: ConceptBreadcrumbProps) => {
    const { trackEvent } = useInteractionTracker();

    return (
      <nav
        aria-label="Breadcrumb"
        className="mb-4 sm:mb-6 lg:mb-8 flex items-center gap-2 text-sm"
      >
        <Link
          aria-label="Back to home"
          className="flex items-center gap-1 text-tertiary hover:text-secondary transition-colors"
          href={ROUTES.CONCEPT_LIST}
          onClick={() =>
            void trackEvent({ action: 'click-breadcrumb', category: 'nav', label: 'home' })
          }
        >
          <Home className="w-4 h-4" />
        </Link>

        <ChevronRight className="w-4 h-4 text-tertiary" />
        <span className="text-tertiary font-medium md:max-w-none max-w-[200px] overflow-hidden whitespace-nowrap text-ellipsis">
          {breadcrumbTitle}
        </span>
      </nav>
    );
  }
);

ConceptBreadcrumb.displayName = 'ConceptBreadcrumb';

export default ConceptBreadcrumb;
